import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Dots } from 'assets/icons';
import DropdownMenu from 'components/DropdownMenu/DropdownMenu';

const MENU_WIDTH = 224;

/**
 * The "…" of a reminder row (JBWEB-1283): suspend or resume, move to
 * litigation or out of it (JBWEB-1284). Rendered in a portal: the table
 * scrolls and would clip it.
 */
const ReminderRowMenu = ({ label, items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const closeOnOutsideClick = (event) => {
      if (triggerRef.current?.contains(event.target)) return;
      if (menuRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [isOpen]);

  const toggleMenu = (event) => {
    event.stopPropagation();
    if (!isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({ top: rect.bottom + 4, left: rect.right - MENU_WIDTH });
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        onClick={toggleMenu}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={label}
        className="flex items-center justify-center w-9 h-9 rounded-md hover:bg-gray-100"
      >
        <Dots w={14} h={4} color="#374151" />
      </button>
      {isOpen &&
        createPortal(
          <div
            ref={menuRef}
            role="menu"
            className="fixed z-[9999]"
            style={{ top: position.top, left: position.left }}
          >
            <DropdownMenu
              width="w-56"
              items={items.map((item) => ({
                ...item,
                onClick: () => {
                  setIsOpen(false);
                  item.onClick();
                },
              }))}
            />
          </div>,
          document.body,
        )}
    </>
  );
};

export default ReminderRowMenu;
